import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IChipsItem } from '../../interfaces/chips-item.interface';
import { SVG_CONSTANTS } from '../../constants/svg.constants';

@Component({
  selector: 'app-chips-selector',
  templateUrl: './chips-selector.component.html',
  styleUrls: ['./chips-selector.component.scss']
})
export class ChipsSelectorComponent implements OnInit {
  CHECK_ICON:string =  `
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="ic-ui-check-24">
  <path id="check" fill-rule="evenodd" clip-rule="evenodd" d="M6.81517 11.859L3.63297 8.44156C3.45568 8.25353 3.45568 7.94749 3.63297 7.75747L4.27578 7.07438C4.45307 6.88636 4.74129 6.88636 4.91858 7.07438L7.13703 9.46668L12.0822 4.14102C12.2595 3.95299 12.5477 3.95299 12.725 4.14102L13.3678 4.8251C13.5451 5.01313 13.5451 5.32017 13.3678 5.50719L7.45798 11.859C7.28068 12.047 6.99247 12.047 6.81517 11.859Z" fill="#FILL_COLOR"/>
  </g>
  </svg>
  `

  CHECK_EMPTY_ICON:string =  `
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="ic-ui-check-24">
  <path id="check" fill-rule="evenodd" clip-rule="evenodd" d="M6.81517 11.859L3.63297 8.44156C3.45568 8.25353 3.45568 7.94749 3.63297 7.75747L4.27578 7.07438C4.45307 6.88636 4.74129 6.88636 4.91858 7.07438L7.13703 9.46668L12.0822 4.14102C12.2595 3.95299 12.5477 3.95299 12.725 4.14102L13.3678 4.8251C13.5451 5.01313 13.5451 5.32017 13.3678 5.50719L7.45798 11.859C7.28068 12.047 6.99247 12.047 6.81517 11.859Z" fill=""/>
  </g>
  </svg>
  `

  @Input() chips: IChipsItem[] = [];
  @Output() selectedChips: EventEmitter<IChipsItem[]> = new EventEmitter<IChipsItem[]>();
  selectedItem: IChipsItem[] = [];

  SVG_CONSTANTS = SVG_CONSTANTS;

  constructor() { }

  ngOnInit(): void { }

  isSelected(item: IChipsItem): boolean {
    return item.isSelected;
  }

  getPrimaryColor(item:IChipsItem):string{
    return item.primaryColor;
  }

  getSecondaryColor(item:IChipsItem):string{
    return item.secondaryColor
  }

  getSvg(svgPath:any, i){
    return svgPath.replace('#FILL_COLOR', this.chips[i].primaryColor)
  }

  isDisabled(item: IChipsItem): boolean {
    return item.isDisabled;
  }

  handleClick(i: number): void {
    this.chips[i].isSelected = !this.chips[i].isSelected;
    if (this.chips[i].isSelected) {
      this.updateSelectedItem(this.chips[i], 'ADD');
    } else {
      this.updateSelectedItem(this.chips[i], 'REMOVE');
    }
  }

  private updateSelectedItem(item: IChipsItem, update: 'ADD' | 'REMOVE'): void {
    const idx = this.selectedItem.findIndex((chip: IChipsItem) => chip.label === item.label);

    switch (update) {
      case 'ADD':
        if (idx === -1) {
          this.selectedItem.push(item);
        }
        break;
      case 'REMOVE':
        if (idx > -1) {
          this.selectedItem.splice(idx, 1);
        }
        break;
    }
    this.selectedChips.emit(this.selectedItem);
  }
}
